import { render, staticRenderFns } from "./SolicitacaoFolga.vue?vue&type=template&id=df7160a4&scoped=true&"
import script from "./SolicitacaoFolga.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoFolga.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoFolga.vue?vue&type=style&index=0&id=df7160a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7160a4",
  null
  
)

export default component.exports